/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, Type } from "@angular/core";
import { ScrBaseComponent } from "../../base.component";
import { NGXLogger } from "ngx-logger";

export class DynamicTab {

  public active: boolean;

  constructor(public name: string,
    public title: string,
    public ctor: any,
    public inputs: (tabName: string, tabClick: boolean) => object) {
    this.active = false;
  }
}

@Component({
  selector: 'app-dynamic-tabpane',
  templateUrl: './dynamic-tabpane.component.html',
  styleUrls: ['./dynamic-tabpane.component.scss']
})
export class DynamicTabpaneComponent implements OnInit, OnChanges, OnDestroy {

  activeComponent!: Type<any>;
  activeComponentInputs = {};

  @Input() public tabs!: DynamicTab[];

  @Input() public defaultTabName!: string;

  @Input() public parent!: ScrBaseComponent;

  eventListenerAbortController = new AbortController();

  public constructor(public logger: NGXLogger) {
    // nothing right now...
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.logger.trace('tabpane changes ' + JSON.stringify(changes.defaultTabName));
    if (changes.defaultTab?.currentValue) {
      this.activateTab(this.defaultTabName);
    }
  }
  ngOnInit(): void {
    if (this.defaultTabName) {
      this.activateTab(this.defaultTabName);
    }

    window.addEventListener("popstate", (event) => {
      //this.logger.trace('dynamic tab pop state event received with ' + JSON.stringify(event.state));
      if (!event.state.page && this.defaultTabName) {
        //this.logger.trace('dtab activating default tab ' + this.defaultTabName);
        this.activateTab(this.defaultTabName);
      }
      if (event.state.page) {
        //this.logger.trace('dtab activating tab ' + event.state.page);
        this.activateTab(event.state.page);
      }
    },
      {
        signal: this.eventListenerAbortController.signal
      });
  }

  ngOnDestroy(): void {
    // remove the listener.
    if (this.eventListenerAbortController) {
      this.eventListenerAbortController.abort();
    }
  }

  public activateTab(name: string, tabClick = false): void {
    this.logger.trace('dtab: activateTab ' + name + ' is click ' + tabClick);
    if (!this.tabs) {
      // this.logger.trace('tabs not initialized');
      return;
    }
    const current = this.tabs.find(t => t.active === true);
    if (current) {
      current.active = false;
    }
    const tab = this.tabs.find(t => t.name === name);
    if (!tab) {
      // this.logger.trace('cannot find tab ' + name);
      return;
    }

    const sameAsCurrent = (tab.name === current?.name);

    this.logger.trace('push ' + tabClick + ' ' + name + ' ' + this.defaultTabName + ' ' + current + ' ' + sameAsCurrent);
    if ((tabClick && !sameAsCurrent) || !current) {
      const state = Object.assign({}, window.history.state, { page: name });
      // this.logger.trace('pushing state ' + JSON.stringify(state));
      window.history.pushState(state, '');
    }

    this.activeComponentInputs = tab.inputs.call(this.parent, tab.name, tabClick);
    this.activeComponent = tab.ctor;
    tab.active = true;


  }
}

